import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Product } from "../../product/models/product";
import { UsageQuotaLogListDto, UsageQuotaStatusDto } from "../models/usage-quota";

@Injectable({
  providedIn: "root",
})
export class UsageQuotaService {
  private url: string;

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string
  ) {
    this.url = baseUrl + "usageQuota";
  }

  getStatus(quotaTypeId: number): Observable<UsageQuotaStatusDto> {
    return this.http.get<UsageQuotaStatusDto>(
      this.url + "/" + quotaTypeId + "/status"
    );
  }

  getPackages(quotaTypeId: number): Observable<Product[]> {
    return this.http.get<Product[]>(
      this.url + "/" + quotaTypeId + "/packages"
    );
  }

  pay(productId: number, returnUrl: string): Observable<string> {
    return this.http.post<string>(this.url + "/pay/" + productId, { ReturnUrl: returnUrl });
  }

  getAuditLog(quotaTypeId: number): Observable<UsageQuotaLogListDto[]> {
    return this.http.get<UsageQuotaLogListDto[]>(
      this.url + "/" + quotaTypeId + "/log"
    );
  }
}
